import Vue from "vue";
import Requests from "@/constants/Requests";
import { isEmpty } from "lodash";

const InfoService = {
  fetchFaq: () => {
    return Vue.prototype.$http.get(Requests.info.faq);
  },
  fetchMeta: () => {
    return Vue.prototype.$http.get(Requests.info.meta);
  },
  requestMoreInfo: params => {
    return Vue.prototype.$http.post(Requests.info.request, params);
  }
};

export { InfoService };
